type N = { __typename?: string };
type ValueOfTypename<T extends N> = T['__typename'];

export function isType<Result extends N, Typename extends ValueOfTypename<Result>>(
  result: Result,
  typename: Typename
): result is Extract<Result, { __typename?: Typename }> {
  return result?.__typename === typename;
}

export function isEither<
  Result extends N,
  Typename extends ValueOfTypename<Result>,
  PossibleTypes extends Array<Typename>
>(
  result: Result,
  typenames: PossibleTypes
): result is Extract<Result, { __typename: (typeof typenames)[number] }> {
  const types = typenames?.filter(type => isType(result, type));
  return types ? types.length > 0 : false;
}

export function onType<Result extends N, Typename extends ValueOfTypename<Result>>(
  result?: Result | undefined | null,
  typename?: Typename
) {
  if (result && isType(result, typename)) {
    return result;
  }
  return null;
}

export function onEither<
  Result extends N,
  Typename extends ValueOfTypename<Result>,
  PossibleTypes extends Array<Typename>
>(result: Result | null | undefined, typenames: PossibleTypes) {
  if (result && isEither(result, typenames)) {
    return result;
  }
  return null;
}
